import { useState } from 'react';

export function ShortcutInstructions() {
  const [copied, setCopied] = useState(false);

  const urlBase = `${window.location.origin}/wallpaper.png?date=`;
  const fullUrl = `${urlBase}{Current Date}`;

  const copy = () => {
    navigator.clipboard.writeText(fullUrl).catch(() => {});
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section className="w-full max-w-[420px] space-y-3 pb-8">
      <h2 className="text-xs font-medium uppercase tracking-widest text-zinc-500">
        Auto-update on iPhone
      </h2>

      <div className="flex items-start gap-2 rounded-xl border border-zinc-800 bg-zinc-900 p-3">
        <code className="flex-1 break-all font-mono text-xs text-zinc-300">
          {urlBase}
          <span className="rounded bg-zinc-700 px-1 text-zinc-100">{'{Current Date}'}</span>
        </code>
        <button
          type="button"
          onClick={copy}
          className="shrink-0 text-xs text-zinc-500 transition-colors hover:text-zinc-200"
        >
          {copied ? 'copied' : 'copy'}
        </button>
      </div>

      <ol className="space-y-2 text-xs text-zinc-400">
        <li className="flex gap-3">
          <span className="shrink-0 text-zinc-600">1.</span>
          <span>
            Open the{' '}
            <a
              href="https://apps.apple.com/app/shortcuts/id915249334"
              target="_blank"
              rel="noopener noreferrer"
              className="text-zinc-300 underline underline-offset-2 hover:text-zinc-100"
            >
              Shortcuts app
            </a>{' '}
            on iPhone and tap <strong className="text-zinc-300">+</strong> to create a new shortcut.
          </span>
        </li>
        <li className="flex gap-3">
          <span className="shrink-0 text-zinc-600">2.</span>
          <span>
            Add a <strong className="text-zinc-300">Get Contents of URL</strong> action. Paste the
            URL above, then replace{' '}
            <code className="rounded bg-zinc-800 px-1 text-zinc-200">{'{Current Date}'}</code> with
            the <strong className="text-zinc-300">Date</strong> magic variable, formatted as{' '}
            <code className="rounded bg-zinc-800 px-1 text-zinc-200">yyyy-MM-dd</code>.
          </span>
        </li>
        <li className="flex gap-3">
          <span className="shrink-0 text-zinc-600">3.</span>
          <span>
            Add a <strong className="text-zinc-300">Set Wallpaper</strong> action → set to{' '}
            <strong className="text-zinc-300">Lock Screen</strong>.
          </span>
        </li>
        <li className="flex gap-3">
          <span className="shrink-0 text-zinc-600">4.</span>
          <span>
            To auto-update daily: go to the <strong className="text-zinc-300">Automation</strong>{' '}
            tab → <strong className="text-zinc-300">+</strong> →{' '}
            <strong className="text-zinc-300">Time of Day</strong>, then select this shortcut to run
            automatically each morning.
          </span>
        </li>
      </ol>
    </section>
  );
}
